import {
  ADMIN_GROUP_NAME,
  USER_GROUP_PREFIX,
  USER_GROUPS
} from "./oidc_constants";

export function get_user(token) {
  let username = "";
  if (token !== null) username = token["profile"]["email"];
  return username;
}

export function is_user_in_admin_group(user) {
  return is_user_in_group(ADMIN_GROUP_NAME, user);
}

export function get_outcomes_user_group(user) {
  let groups = get_user_groups(user);
  var user_groups = groups.filter(function (group) {
    return group.startsWith(USER_GROUP_PREFIX);
  });

  if (user_groups.length > 0){
    var user_groups_onboarded = USER_GROUPS.filter(function (group) {
      return group.GroupName === user_groups[0];
    });

    return user_groups_onboarded[0];
  }
  return null;
}

export function is_user_in_user_group(user) {
  let user_group = get_outcomes_user_group(user);

  return user_group !== null;
}

export function is_user_in_group(group_name, user) {
  let is_user_in_dev_group_flag = false;
  if (user !== null)
    is_user_in_dev_group_flag =
      user.profile["cognito:groups"].includes(group_name);

  return is_user_in_dev_group_flag;
}

export function is_user_admin(token) {
  let user = get_user(token);
  if (user !== null) {
    let is_user_ttd_flag = user.includes("@thetradedesk.com");
    let is_user_in_admin_group_flag = is_user_in_admin_group();

    if (is_user_ttd_flag === true && is_user_in_admin_group_flag === true)
      return true;
  }
  return false;
}

export function get_user_groups(user) {
  return user.profile["cognito:groups"];
}
